// extracted by mini-css-extract-plugin
export default {"edit":"Passengers_edit__sp9Q1","cancel":"Passengers_cancel__-m96R"};